import React, { useState, useEffect } from "react"

import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import TextField from "@material-ui/core/TextField"
import Divider from "@material-ui/core/Divider"
import Button from "@material-ui/core/Button"
import CircularProgress from "@material-ui/core/CircularProgress"

import useDefaultStyles from "../../../styles/default"

import api from "../../../services/api"
import { useValidation } from "../../../services/validation"
import { useNavigation } from "../../../services/navigation"

import { submitOnPressEnter } from "../../../utils/submit"

import Notification from "../../../components/Notification"

const ResetPassword = () => {
	const { getRouteParams, getParsedQueryParams, navigate } = useNavigation()

	const { hash } = getRouteParams()
	const { token } = getParsedQueryParams()

	const inputs = ["password"]
	const [validation, clearValidation, triggerValidation] = useValidation(inputs)

	const defaultClasses = useDefaultStyles()

	const [password, setPassword] = useState("")
	const [loading, setLoading] = useState(false)

	const handleLogin = async () => {
		setLoading(true)

		try {
			await api.put(`/home/hash/${hash}/password/recovery`, { password, token })
			Notification.success("Senha alterada com sucesso!")
			navigate(`/${hash}/login`)
		} catch (error) {
			triggerValidation(error)
		}

		setLoading(false)
	}

	const handleChangePassword = (value) => {
		setPassword(value)
		clearValidation("password")
	}

	useEffect(() => {
		submitOnPressEnter()
	}, [])

	return (
		<Container className={defaultClasses.container}>
			<Typography variant="h6">
				Mudança de Senha
			</Typography>

			<Typography variant="subtitle1">
				Digite sua nova senha abaixo no campo.
			</Typography>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<TextField
				required
				label="Nova senha"
				type="password"
				autoComplete="current-password"
				variant="standard"
				color="secondary"
				size="small"
				value={password}
				error={!!validation.password.validateStatus}
				helperText={validation.password.help}
				onChange={({ target }) => handleChangePassword(target.value)}
			/>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<Button
				variant="contained"
				color="secondary"
				className={defaultClasses.buttonBlock}
				onClick={() => handleLogin()}
				disabled={loading}
				endIcon={loading && <CircularProgress size={20} />}
				id="submit"
			>
				Alterar senha
			</Button>
		</Container>
	)
}

export default ResetPassword